/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { riskPresetsList } from "../funcs/riskPresetsList.js";
import { riskPresetsSuggest } from "../funcs/riskPresetsSuggest.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { RiskPresetsResult } from "../models/components/riskpresetsresult.js";
import { SuggestRiskPolicyResult } from "../models/components/suggestriskpolicyresult.js";
import {
  ListRiskPresetsRequest,
  ListRiskPresetsSecurity,
} from "../models/operations/listriskpresets.js";
import {
  SuggestRiskPolicyRequest,
  SuggestRiskPolicySecurity,
} from "../models/operations/suggestriskpolicy.js";
import { unwrapAsync } from "../types/fp.js";

export class Presets extends ClientSDK {
  /**
   * listRiskPresets risk
   *
   * @remarks
   * Return the use-case presets a risk policy can start from. Each preset resolves to a complete create payload (policy type, detectors, action, severity and, for prompt-based presets, the judge instruction) so the dashboard and the Platform MCP offer the same starting points.
   */
  async list(
    request?: ListRiskPresetsRequest | undefined,
    security?: ListRiskPresetsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskPresetsResult> {
    return unwrapAsync(riskPresetsList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * suggestRiskPolicy risk
   *
   * @remarks
   * Map a plain-language description of a risk to a policy draft: the closest preset with its detectors, action and severity, or a bespoke prompt-based guardrail when no preset fits. Uses the configured LLM when available and a deterministic keyword match otherwise. Nothing is created.
   */
  async suggest(
    request: SuggestRiskPolicyRequest,
    security?: SuggestRiskPolicySecurity | undefined,
    options?: RequestOptions,
  ): Promise<SuggestRiskPolicyResult> {
    return unwrapAsync(riskPresetsSuggest(
      this,
      request,
      security,
      options,
    ));
  }
}
